import React, { ChangeEvent, useRef, useCallback } from 'react'
import { useEffect, useMemo, useState } from 'react'
import {
  formatDate,
  alert,
  toast,
  setOptions,
  MbscCalendarEvent,
  MbscEventcalendarView,
  MbscResource,
  Select,
  SegmentedGroup,
  Segmented,
  Datepicker,
  Switch
} from '@mobiscroll/react'
import {
  Eventcalendar,
  CalendarPrev,
  CalendarNext,
  MbscCalendarEventData,
  MbscRecurrenceRule,
  Button,
  Input,
  MbscCalendarDayData
} from '@mobiscroll/react-latest'
import '@mobiscroll/react-latest/dist/css/mobiscroll.min.css'
import '@mobiscroll/react/dist/css/mobiscroll.min.css'
import '../App.css'
import {
  IDriverSearchObject,
  IVehicleObj,
  IDriverCalendar,
  IVehicleCalendar,
  IActiveTripResponseV2,
  ITripFilters,
  IVehicleFilters,
  ISimpleDriverDTO,
  TimelineViewDisplayType,
  IAccessAndCapacity,
  ILocationV2,
  IMbscColors,
  IDriverScheduleDTO,
  ITripEdit,
  IDriverMetricsDTO,
  IDriverMetricsDTOObject,
  IDriverMetricsResponse,
  IDestinations,
  IDriveTimesDTO,
  IRiderFilters
} from 'src/types'
import moment from 'moment'
import {
  TripStatuses,
  activeTripStatusesWithDriver,
  cancelledTripsStatusesDashboard,
  completedTripStatuses,
  completedTripStatusesDashboard,
  failedTripStatusesDashboard,
  unsassignedTripStatusesDashboard
} from 'src/constants/trip-statuses'
import { Link } from 'react-router-dom'
import ArrowRightWithTailSM from '../../icons/ui/ArrowRightWithTailSM'
import { CITIES } from 'src/constants/Countries'
import TripDetailLocation from '../../../containers/trips/location'
import Popup from 'reactjs-popup'
import ETADisplay from '../trip-detail/ETA'
import GearIcon from '../../icons/ui/GearIcon'
import Close from '../../icons/ui/Close'
import TimelineEventPopup from './TimelineEventPopup'
import { driversService } from 'src/services/Drivers'
import UpdatedTooltip from '../../ui/UpdatedTooltip'
import {
  getMetricsFromLocalStorage,
  getStorageKey,
  saveMetricsToLocalStorage
} from 'src/state/actions/drivers/local-storage'
import { getTripDetails } from 'src/state/actions/trips'
import { tripService } from 'src/services/Trip'
import TimelineSchedulePopup from './TimelineSchedulePopup'
import { debounce } from 'throttle-debounce'
import { riderService } from 'src/services/Rider'
import ImageView from '../../ui/ImageView'
import TimelineViewSelectedRider from './TimelineViewSelectedRider'
import {
  dateFormat,
  initialDriverMessage,
  initialRiderMessage,
  noResultFoundDriverMessage,
  noResultFoundRiderMessage,
  tripColors
} from 'src/constants/trip'
import GoBackIcon from '../../icons/ui/GoBack'
import Toggle from 'src/components/ui/Toggle'
import TimelineViewBusyTimes from './TimeLineViewBusyTimes'

setOptions({
  theme: 'ios',
  themeVariant: 'light'
})

interface ITripsSchedulerCalendarProps {
  orgId: string
  drivers: IDriverSearchObject[]
  vehicles: IVehicleObj[]
  vehicleFilters: IVehicleFilters
  trips: IActiveTripResponseV2[]
  tripFilters: ITripFilters
  activeDrivers: IDriverSearchObject[]
  operatorSchedule: IDriverScheduleDTO[]
  fetchTrips: (params: ITripFilters) => void
  fetchAllVehicles: (params: IVehicleFilters) => void
  fetchOperatorSchedule: () => void
  assignOperator: (tripId: string, lastStatus: string, operator: ISimpleDriverDTO, isOndemandTrip: boolean) => any
  updateTripFilters: (filters: ITripFilters) => void
  setCurrentTrip: (tripId: string) => void
  assignScheduledGroupRideOperator: (id: string, operator: ISimpleDriverDTO) => Promise<any>
  unAssignScheduledGroupRideOperator: (id: string) => Promise<any>
  saveData: (params: ITripEdit) => Promise<any>
  updateSingleTrip: (trip: IActiveTripResponseV2) => Promise<any>
}
const pendingAndActiveTripStatuses = [
  TripStatuses.SCHEDULE_REQUESTED,
  TripStatuses.WAITING,
  TripStatuses.SCHEDULED,
  TripStatuses.REQUESTED,
  TripStatuses.COMPLETED,
  ...activeTripStatusesWithDriver
]

interface ITimelineSettings {
  currentTimeIndicator: boolean
  endDay: number
  endTime: string
  eventList: boolean
  startDay: number
  startTime: string
  timeCellStep: number
  timeLabelStep: number
  weekNumbers: boolean
}
interface IEventDestinations {
  id: string
  destinations: IDestinations[]
}

interface IScheduleEvent extends MbscCalendarEvent {
  repeat: MbscRecurrenceRule
}

interface IEventParams {
  name: string
  value: boolean | number | string
}
interface ITimelineControlsMenuProps {
  timelineSettings: ITimelineSettings
  onChange: (params: IEventParams) => void
  onClose: () => void
}

interface ITimelineViewRider {
  id: string
  name: string
  firstName: string
  lastName: string
  phone: string
  email: string
  serviceMemberships: ITimelineViewServiceMembership[]
  birthDate: string | Date
  type: 'rider'
}

interface ITimelineViewServiceMembership {
  id: string
  externalRiderId: string
  beginsAt: string | null
  expiresAt: string | null
  recurringType: string | null
  ridesNum: number | null
  ridesRangeType: string | null
  requestedAt: string
  status: string
  type: string
  notAllowedPCA: boolean
  service: {
    id: string
    name: string
  }
}

const TimelineControlsMenu = ({ timelineSettings, onChange, onClose }: ITimelineControlsMenuProps) => {
  const {
    currentTimeIndicator,
    endDay,
    endTime,
    eventList,
    startDay,
    startTime,
    timeCellStep,
    timeLabelStep,
    weekNumbers
  } = timelineSettings

  const [displayDaysFrom, setDisplayDaysFrom] = useState(startDay)

  const days = [
    { text: 'Sunday', value: 0 },
    { text: 'Monday', value: 1 },
    { text: 'Tuesday', value: 2 },
    { text: 'Wednesday', value: 3 },
    { text: 'Thursday', value: 4 },
    { text: 'Friday', value: 5 },
    { text: 'Saturday', value: 6 }
  ]

  const time = [
    { text: '5 minutes', value: 5 },
    { text: '10 minutes', value: 10 },
    { text: '15 minutes', value: 15 },
    { text: '30 minutes', value: 30 },
    { text: '1 hour', value: 60 },
    { text: '2 hours', value: 120 },
    { text: '3 hours', value: 180 },
    { text: '4 hours', value: 240 },
    { text: '6 hours', value: 360 },
    { text: '8 hours', value: 480 },
    { text: '12 hours', value: 720 },
    { text: '24 hours', value: 1440 }
  ]

  const parseStateValue = () => {
    const timeRange = [startTime, endTime].map(time => {
      const date = new Date()
      const hour = time.split(':')[0]
      date.setHours(Number(hour))
      date.setMinutes(0)
      date.setSeconds(0)
      return date
    })
    return timeRange
  }

  const handleDisplayHours = (timeRange: Date[]) => {
    const parseDays = timeRange.map((time: Date) => moment(time).format('HH:mm'))
    parseDays.forEach((time, index) => {
      onChange({
        name: index === 0 ? 'startTime' : 'endTime',
        value: time
      })
    })
  }

  const filterOptions = () => days.filter(day => day.value > displayDaysFrom)

  return (
    <React.Fragment>
      <div className='fixed bg-white p3 scheduler-timeline-control'>
        <Close className='absolute cursor--pointer icon--12x12 right-1 svg-grey top-1' onClick={onClose} />
        <div className='pb1'>
          <span>Display timeline days :</span>
          <div className='g-flex scheduler-timeline-days'>
            <div>
              <label>From</label>
              <Select
                data={days}
                display='anchored'
                showArrow={false}
                touchUi={false}
                value={startDay}
                onChange={({ value }) => {
                  setDisplayDaysFrom(value)
                  onChange({ name: 'startDay', value })
                }}
              />
            </div>
            <div>
              <label>To</label>
              <Select
                data={filterOptions()}
                display='anchored'
                showArrow={false}
                touchUi={false}
                value={endDay}
                onChange={({ value }) => onChange({ name: 'endDay', value })}
              />
            </div>
          </div>
        </div>
        <div className='g-flex items-center justify-between py1'>
          <label className='pr1'>Display hours (from - to) :</label>
          <Datepicker
            controls={['timegrid']}
            inputProps={{
              className: 'scheduler-timeline-timepicker'
            }}
            rangeEndLabel='To'
            rangeStartLabel='From'
            select='range'
            stepMinute={60}
            timeFormat='HH:mm'
            value={parseStateValue()}
            onChange={({ value }) => handleDisplayHours(value as Date[])}
          />
        </div>
        <div className='g-flex items-center justify-between py1'>
          <label className='pr1'>Set the time scale to :</label>
          <Select
            data={time}
            display='anchored'
            showArrow={false}
            touchUi={false}
            value={timeCellStep}
            onChange={({ value }) => onChange({ name: 'timeCellStep', value })}
          />
        </div>
        <div className='g-flex items-center justify-between py1'>
          <label className='pr1'>Show time labels every :</label>
          <Select
            data={time}
            display='anchored'
            showArrow={false}
            touchUi={false}
            value={timeLabelStep}
            onChange={({ value }) => onChange({ name: 'timeLabelStep', value })}
          />
        </div>
        <div className='schedule-timeline-switch'>
          <Switch
            checked={eventList}
            color='success'
            label='Show a daily summary of events'
            position='start'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { checked } = e.target
              onChange({ name: 'eventList', value: checked })
            }}
          />
          <Switch
            checked={weekNumbers}
            color='success'
            label='Show week numbers'
            position='start'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { checked } = e.target
              onChange({ name: 'weekNumbers', value: checked })
            }}
          />
          <Switch
            checked={currentTimeIndicator}
            color='success'
            label='Show current time indicator'
            position='start'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { checked } = e.target
              onChange({ name: 'currentTimeIndicator', value: checked })
            }}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
const TripsSchedulerCalendar = (props: ITripsSchedulerCalendarProps) => {
  const PASTEL_YELLOW = '#F3EFCF'
  const PASTEL_RED = '#F3E0E0'
  const LIGHT_GRAY = '#F7F7F7'
  const DRIVER_STATUS_COLOR = {
    blue: '#137CBD',
    green: '#37C47E',
    yellow: '#FFD400',
    red: '#FF0000',
    white: '#FFFFFF'
  }
  const OPERATOR_SESSION_TYPES = {
    BREAK: 'break',
    WORK_TIME: 'work_time'
  }

  const driverAvailableBg = PASTEL_YELLOW
  const driverUnavailableBg = PASTEL_RED
  const driverNoScheduleBg = LIGHT_GRAY

  const defaultMetrics = {
    totalTripHours: 0,
    totalClockedInHours: 0,
    revenuePerHour: 0,
    revenuePercentage: 0
  }

  const [viewMode, setViewMode] = useState<'day' | 'week' | 'month'>('day')
  const [viewType, setViewType] = useState<string>('timeline')
  const [drivers, setDrivers] = useState<IDriverCalendar[]>([])
  const [events, setEvents] = useState<MbscCalendarEvent[]>([])
  const [vehicles, setVehicles] = useState<IVehicleCalendar[]>([])
  const [unassignedVehicles, setUnassignedVehicles] = useState<IVehicleCalendar[]>([]) // uncomment to return back unassigned vehicle
  const [currentDate, setCurrentDate] = useState(new Date())
  const [filteredBy, setFilteredBy] = useState(TimelineViewDisplayType.DRIVER)
  const [toggleControls, setToggleControls] = useState(false)
  const [eventDestinations, setEventDestinations] = useState<IEventDestinations[]>([])
  const [timelineSettings, setTimelineSettings] = useState({
    currentTimeIndicator: true,
    endDay: 6,
    endTime: '23:59',
    eventList: false,
    startDay: 0,
    startTime: '00:00',
    timeCellStep: 5,
    timeLabelStep: 30,
    weekNumbers: false
  })
  const [view, setView] = useState<MbscEventcalendarView>({
    timeline: {
      type: 'day',
      timeCellStep: 5,
      timeLabelStep: 30
    }
  })
  // Operator drive times
  const [driveTimes, setDriveTimes] = useState<IDriveTimesDTO[]>([])
  // Event tooltip related variables
  const [eventInfo, setEventInfo] = useState<MbscCalendarEvent>()
  const [scheduleInfo, setScheduleInfo] = useState<MbscCalendarEvent>()
  const [tooltipAnchor, setTooltipAnchor] = useState()
  const [isScheduleTooltipOpen, setIsScheduleTooltipOpen] = useState<boolean>(false)
  const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false)
  const [driverMetrics, setDriverMetrics] = useState<IDriverMetricsDTO[]>([])
  const timer = useRef<ReturnType<typeof setTimeout>>()
  const [tooltipLoading, setTooltipLoading] = useState<boolean>(true)
  const anchorRef = useRef<HTMLDivElement | null>(null)
  const [selectedLookup, setSelectedLookup] = useState<'driver' | 'rider' | 'vehicle'>('driver')
  const tripRef = useRef<HTMLDivElement | null>(null)
  const [hoveringTooltip, setHoveringTooltip] = useState<boolean>(false)
  const [exludedStatus, setExcludedStatus] = useState<string>('')
  const [showCancelled, setShowCancelled] = useState<boolean>(true)
  const [collapsedState, setCollapsedState] = useState<Record<string, boolean>>({})
  const [riderQuery, setRiderQuery] = useState<string>('')
  const [driverQuery, setDriverQuery] = useState<string>('')
  const [riders, setRiders] = useState<ITimelineViewRider[]>([])
  const [selectedRider, setSelectedRider] = useState<ITimelineViewRider | null>(null)
  const [riderMessage, setRiderMessage] = useState<string>(initialRiderMessage)
  const [driverMessage, setDriverMessage] = useState<string>(initialDriverMessage)
  const [tripEvents, setTripEvents] = useState<MbscCalendarEvent[]>([])
  const [pinnedDrivers, setPinnedDrivers] = useState<string[]>([])
  const [dateText, setDateText] = useState<string>(moment().format(dateFormat))
  // END of tooltip related variables

  const { operatorSchedule, fetchOperatorSchedule } = props

  useEffect(() => {
    return () => {
      console.log('Component unmounted')
      handleComponentUnmount()
    }
  }, [])

  useEffect(() => {
    let timeStart
    let timeEnd

    if (viewMode === 'day') {
      timeStart = moment(currentDate)
        .startOf('day')
        .toISOString()
      timeEnd = moment(currentDate)
        .endOf('day')
        .toISOString()
    } else {
      timeStart = moment(currentDate)
        .startOf('week')
        .toISOString()
      timeEnd = moment(currentDate)
        .endOf('week')
        .toISOString()
    }

    props.updateTripFilters({
      ...props.tripFilters,
      timeStart,
      timeEnd
    })
  }, [currentDate])

  const handleComponentUnmount = () => {
    console.log('Cleaning up timeline filter...')
    props.updateTripFilters({ excludeStatuses: [] })
  }

  useEffect(() => {
    if (!props.drivers) {
      return
    }
    let drivers = props.drivers.map((item: any) => {
      let capacities: IAccessAndCapacity[] = []
      if (props.vehicles) {
        const ve = props.vehicles.find(v => {
          if (item.vehicle) {
            return v.id === item.vehicle.id
          }
          return false
        })
        capacities = ve ? ve.capacities : []
      }

      const metrics = driverMetrics.find(driver => driver.operatorId === item.id)

      const finalMetrics = metrics ? metrics : defaultMetrics
      return {
        id: item.id,
        name: item.name,
        type: 'driver',
        color: getDriverStatusColor(item, props.trips),
        vehicleCapacities: capacities,
        ...finalMetrics
      }
    })

    if (driverQuery) {
      drivers = drivers.filter(driver => driver.name.toLowerCase().includes(driverQuery.toLowerCase()))
    }

    const { blue, green, red, white, yellow } = DRIVER_STATUS_COLOR
    const statusOrder = [blue, green, yellow, red, white]
    drivers.sort((a, b) => statusOrder.indexOf(a.color) - statusOrder.indexOf(b.color))

    if (drivers.length === 0 && driverQuery.length > 0) {
      setDriverMessage(noResultFoundDriverMessage)
    } else {
      setDriverMessage(initialDriverMessage)
    }

    setDrivers(drivers)
  }, [props.drivers, props.trips, props.vehicles, driverMetrics, driverQuery])

  useEffect(() => {
    fetchOperatorSchedule()

    const intervalCall = () => {
      getDriverMetrics()
    }

    // Set up an interval to call the function every hour (3600000 milliseconds)
    const intervalId = setInterval(intervalCall, 5400000)
    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    getDriverMetrics()
  }, [dateText, props.orgId])

  useEffect(() => {
    computeDriveTimes()
  }, [viewMode])

  useEffect(() => {
    props.fetchAllVehicles(props.vehicleFilters)
  }, [props.vehicleFilters])

  useEffect(() => {
    if (!props.vehicles) {
      return
    }
    const vehicles: IVehicleCalendar[] = []
    const unassignedVehicles: IVehicleCalendar[] = []
    props.vehicles.forEach((item: any) => {
      ;(item.operator === null ? unassignedVehicles : vehicles).push({
        id: item.id,
        color: item.color,
        name: item.type,
        operator: item.operator,
        licensePlate: item.licensePlate,
        type: item.operator === null ? 'unassigned-vehicle' : 'vehicle'
      })
    })
    setVehicles(vehicles)
    setUnassignedVehicles(unassignedVehicles) // uncomment to set unassignedvehicles
  }, [props.vehicles])

  useEffect(() => {
    const dateChangeArgs = {
      date: currentDate
    }
    onSelectedDateChange(dateChangeArgs)
  }, [view])

  useEffect(() => {
    const calEvents = props.trips.map((item: IActiveTripResponseV2) => {
      const resource = []
      // Link trip to rider
      if (item.rider) {
        resource.push(item.rider.riderId)
      }
      // Link trip to driver
      if (item.operator) {
        resource.push(item.operator.operatorId)
      } else {
        resource.push('unassigned-res')
      }
      // Link trip to vehicle
      if (item.vehicle) {
        const vehicle = props.vehicles
          ? props.vehicles.find(vehicle => {
              if (item.operator && vehicle.operatorId === item.operator.operatorId) {
                return true
              }
              return false
            })
          : undefined
        resource.push(vehicle ? vehicle.id : '')
      }

      const pickUpAddr = item.pickupLocation.city || item.pickupLocation.placeName
      const dropOff = item.dropoffLocation.city || item.dropoffLocation.placeName
      const header = `${pickUpAddr} to ${dropOff} `

      const body = `${item.rider.firstName} ${item.rider.lastName} ${item.riderCount} ${item.product.name}`

      const pickUpTime = moment(item.scheduledPickupTime)
      const dropOffTime = moment(item.scheduledDropoffTime)
      // adjust display of time if pickup and drop times are the same so it could be more readable in the timeline
      const pickUpNDropoffTimeIsNull = (aTime: string | undefined, bTime: string | undefined) => {
        return !aTime && !bTime
      }
      const dropOffTimeDisplay = dropOffTime

      // we need to identify if the trip is an on-demand
      // to be able to identify when to base the startTime and endTime
      const isTripOnDemand = item.status.map(s => s.status).includes(TripStatuses.REQUESTED)
      const startTime = pickUpNDropoffTimeIsNull(item.scheduledPickupTime, item.scheduledDropoffTime)
        ? isTripOnDemand
          ? moment(item.createdAt)
          : moment()
        : pickUpTime
      const endTime = pickUpNDropoffTimeIsNull(item.scheduledPickupTime, item.scheduledDropoffTime)
        ? isTripOnDemand
          ? moment(item.createdAt)
          : moment()
        : dropOffTime.isValid()
        ? dropOffTimeDisplay
        : pickUpTime

      const { cssClass, color } = getTripBlockColor(item, endTime)

      const etaOrigin = item.operatorLocation
        ? {
            lat: item.operatorLocation.coordinates[1],
            lng: item.operatorLocation.coordinates[0]
          }
        : null

      const etaDestinationPickup = item.operatorLocation
        ? {
            lat: item.pickupLocation.latitude,
            lng: item.pickupLocation.longitude
          }
        : null

      const etaDestinationDropoff = item.operatorLocation
        ? {
            lat: item.dropoffLocation.latitude,
            lng: item.dropoffLocation.longitude
          }
        : null

      const loadingTime = item.product.estimatedLoadingTime !== null ? item.product.estimatedLoadingTime : 0

      return {
        id: item.id,
        driver: item.operator,
        vehicle: item.vehicle,
        resource,
        start: startTime.format('YYYY-MM-DDTHH:mm:ss'),
        end: endTime.format('YYYY-MM-DDTHH:mm:ss'),
        title: header, // TODO: what should be the title?
        pickUp: pickUpAddr,
        dropOff,
        pickupLocation: item.pickupLocation,
        dropOffLocation: item.dropoffLocation,
        lastStatus: item.lastStatus,
        product: item.product,
        riderCount: item.riderCount,
        cssClass,
        color,
        trip: item,
        etaOrigin,
        etaDestinationPickup,
        etaDestinationDropoff,
        bufferAfter: loadingTime,
        bufferBefore: loadingTime,
        destinations: item.destinations
        // TODO: add other fields that are needed here:
      }
    })

    const scheduleEvents: MbscCalendarEvent[] = props.operatorSchedule.map((schedule: IDriverScheduleDTO) => {
      return {
        start: schedule.from,
        end: schedule.until,
        title: 'Daily Shift',
        resource: [schedule.operator_id],
        recurring: {
          repeat: 'weekly',
          weekDays: formatToMbscDay(schedule.days)
        },
        color: '#F3EFCF',
        cssClass: '',
        type: 'shift'
      }
    })
    setTripEvents(calEvents)
    setEvents([...calEvents, ...scheduleEvents])
  }, [props.trips, props.operatorSchedule])

  useEffect(() => {
    const { timeline } = view
    if (!!timeline) {
      setView(prev => ({
        timeline: {
          ...prev.timeline,
          ...timelineSettings
        }
      }))
    }
  }, [timelineSettings])

  const handleChangeSettings = (event: IEventParams) => {
    const { name, value } = event
    setTimelineSettings(prev => ({
      ...prev,
      [name]: value
    }))
  }

  /**
   * Fix on unassigned request sticky position overlapping the driver resources
   */
  if (viewType === 'timeline') {
    const gridElement = document.querySelector('.mbsc-timeline-grid')
    if (gridElement) {
      const rowElement = gridElement.firstElementChild
      const rowElementStyle = rowElement && rowElement.getAttribute('style')
      const timelineDay = rowElement && rowElement.querySelectorAll('.mbsc-timeline-day')
      if (rowElementStyle && timelineDay) {
        timelineDay.forEach(element => element.setAttribute('style', rowElementStyle))
      }
    }
  }

  const mergeAndAggregate = (arr1: IDriverMetricsDTO[], arr2: IDriverMetricsDTO[]) => {
    const combined = [...arr1, ...arr2]

    return Object.values(
      combined.reduce<IDriverMetricsDTOObject>((acc, item) => {
        const {
          operatorId,
          operatorName,
          organizationId,
          totalTripHours,
          totalClockedInHours,
          revenuePerHour,
          revenuePercentage
        } = item

        if (!acc[operatorId]) {
          acc[operatorId] = {
            operatorId,
            operatorName,
            organizationId,
            totalTripHours: 0,
            totalClockedInHours: 0,
            revenuePerHour: 0,
            revenuePercentage: 0
          }
        }

        acc[operatorId].totalTripHours += parseFloat(totalTripHours.toString())
        acc[operatorId].totalClockedInHours += parseFloat(totalClockedInHours.toString())
        acc[operatorId].revenuePerHour += parseFloat(revenuePerHour.toString())
        acc[operatorId].revenuePercentage += parseFloat(revenuePercentage.toString())

        return acc
      }, {})
    )
  }

  const calculateTimeBoundaries = (date: Date, mode: string) => {
    let timeStart
    let timeEnd

    if (mode === 'day') {
      timeStart = moment(date)
        .startOf('day')
        .toISOString()
      timeEnd = moment(date)
        .endOf('day')
        .toISOString()
    } else {
      timeStart = moment(date)
        .startOf('week')
        .toISOString()
      timeEnd = moment(date)
        .endOf('week')
        .toISOString()
    }

    return { timeStart, timeEnd }
  }

  const getOperatorMetrics = async (organizationId: string, startDate: string, endDate: string, timezone: string) => {
    const storageKey = getStorageKey({
      organizationId,
      startDate,
      endDate,
      timezone
    })

    const storedMetrics = getMetricsFromLocalStorage(storageKey)

    if (storedMetrics) {
      return Promise.resolve(storedMetrics)
    }
    return driversService
      .getOperatorMetrics({
        organizationId,
        startDate,
        endDate,
        timezone
      })
      .then(
        (data: IDriverMetricsResponse) => {
          saveMetricsToLocalStorage(storageKey, data.items)
          return data.items
        },
        (error: string) => {
          console.error(error)
          return []
        }
      )
  }

  const computeDriveTimes = async () => {
    const { orgId: organizationId } = props
    const timezone = moment.tz.guess()
    const startDate = moment(currentDate)
      .startOf(viewMode)
      .toISOString()
    const endDate = moment(currentDate)
      .endOf(viewMode)
      .toISOString()

    try {
      const { items = [] } =
        (await driversService.computeOperatorDriveTimes({ startDate, endDate, organizationId, timezone })) || []
      setDriveTimes(items)
    } catch (error) {
      console.log('Failed to compute operator drive times', error)
      setDriveTimes([])
    }
  }

  const getDriverMetrics = async () => {
    const start = moment(dateText, dateFormat)
      .startOf('day')
      .toISOString()

    const end = moment(dateText, dateFormat)
      .endOf('day')
      .toISOString()

    // Temporarily disabling driver metrics until backend optimization
    // const response = await getOperatorMetrics(props.orgId, start, end, moment.tz.guess())
    const response: IDriverMetricsDTO[] = []
    setDriverMetrics(response)
    return response
  }

  const getTripBlockColor = (trip: IActiveTripResponseV2, dropOffTime: moment.Moment) => {
    const now = moment()
    const tripTimeDiff = now.diff(dropOffTime, 'seconds')
    const { lastStatus: status } = trip

    if (unsassignedTripStatusesDashboard.includes(status)) {
      return { cssClass: '', color: tripColors.GRAY }
    }

    if (cancelledTripsStatusesDashboard.includes(status)) {
      return { cssClass: '', color: tripColors.TUSCAN }
    }

    if (status === TripStatuses.COMPLETED) {
      return { cssClass: 'strikethrough', color: tripColors.GRAY }
    }

    // Check if the trip is active and drop off time is late for 30 mins or more
    if (tripTimeDiff >= 1800) {
      if (tripTimeDiff >= 3600) {
        // More than an hour late - red
        return { cssClass: '', color: tripColors.RED }
      } else {
        // Between 30 mins and an hour late - orange
        return { cssClass: '', color: tripColors.ORANGE }
      }
    } else {
      // Active trip with no issue - blue
      return { cssClass: '', color: tripColors.BLUE }
    }
  }

  const validateOperatorSchedules = (id: string) => {
    const schedules = operatorSchedule.filter(sched => sched.operator_id === id)
    if (schedules.length) {
      const arrDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      const today = arrDays[moment(currentDate).day()]
      const scheduleForToday = schedules.filter(sched => sched.days.includes(today))
      if (scheduleForToday.length) {
        const schedule: boolean[] = []
        scheduleForToday.forEach(({ from, until }) => {
          const startTime = moment(from, 'HH:mm')
          const endTime = moment(until, 'HH:mm')
          const withSchedule = moment().isBetween(startTime, endTime)
          schedule.push(withSchedule)
        })
        return schedule.includes(true)
      }
      return false
    }
    return false
  }

  const getDriverStatusColor = (driver: IDriverSearchObject, trips: IActiveTripResponseV2[]) => {
    const { blue, green, red, white, yellow } = DRIVER_STATUS_COLOR
    //find driver in live drivers list
    const isOperatorHasSchedule = validateOperatorSchedules(driver.id)
    const activeDriver = props.activeDrivers.find(d => d.id === driver.id)
    if (driver.check_out_time) {
      if (isOperatorHasSchedule) {
        return red
      }
      return white
    } else if (driverIsInTrip(driver, trips) && activeDriver) {
      return blue
    } else if (
      activeDriver &&
      (!driver.check_out_time && driver.operator_session_type !== OPERATOR_SESSION_TYPES.BREAK)
    ) {
      return green
    } else if (!driver.check_out_time && driver.operator_session_type === OPERATOR_SESSION_TYPES.BREAK) {
      return yellow
    } else {
      return white
    }
  }

  const driverIsInTrip = (driver: IDriverSearchObject, trips: IActiveTripResponseV2[]) => {
    let isInTrip = false
    if (trips !== null && trips !== undefined) {
      trips.forEach(trip => {
        if (trip.operator && trip.operator.operatorId === driver.id) {
          const stillInTripStatuses = [
            TripStatuses.ACCEPTED,
            TripStatuses.AT_PICK_UP,
            TripStatuses.PICKED_UP,
            TripStatuses.AT_DROP_OFF,
            TripStatuses.TO_PICK_UP,
            TripStatuses.TO_DROP_OFF
          ]
          const finishedTripStatuses = [
            ...completedTripStatuses,
            ...completedTripStatusesDashboard,
            ...cancelledTripsStatusesDashboard,
            ...unsassignedTripStatusesDashboard,
            ...failedTripStatusesDashboard
          ]

          if (stillInTripStatuses.includes(trip.lastStatus) && !finishedTripStatuses.includes(trip.lastStatus)) {
            isInTrip = true
          }
        }
      })
    }
    return isInTrip
  }

  // this allows to display selected view if drivers or vehicles only
  const resources = useMemo(() => {
    // Process vehicles to link them to the assigned drivers
    vehicles.forEach(vehicle => {
      if (vehicle.operator) {
        const driver = drivers.find(d => d.id === vehicle.operator.id)
        if (driver) {
          // Map vehicle to driver for use in template
          driver.vehicle = vehicle
          // Map driver to vehicle for use in template
          vehicle.driver = driver
        }
      }
    })
    if (selectedLookup === 'driver') {
      const { blue, green, red, white, yellow } = DRIVER_STATUS_COLOR

      const onTripDrivers = drivers.filter(driver => driver.color === blue && !pinnedDrivers.includes(driver.id))
      const onlineDrivers = drivers.filter(driver => driver.color === green && !pinnedDrivers.includes(driver.id))
      const onBreakDrivers = drivers.filter(driver => driver.color === yellow && !pinnedDrivers.includes(driver.id))
      const absentDrivers = drivers.filter(driver => driver.color === red && !pinnedDrivers.includes(driver.id))
      const offlineDrivers = drivers.filter(driver => driver.color === white && !pinnedDrivers.includes(driver.id))
      const pinDrivers = drivers.filter(driver => pinnedDrivers.includes(driver.id))

      const driverResource: MbscResource[] = [
        {
          id: 'unassigned-res',
          name: 'Unassigned Requests',
          type: 'unassigned',
          color: 'gray',
          fixed: true
        },
        {
          id: 'initial-driver',
          name: 'Initial Driver',
          type: 'initial-driver',
          color: 'white'
        }
      ]

      const driverGroups = [
        { id: 'pinned-drivers-res', name: 'Pinned', drivers: pinDrivers },
        { id: 'ontrip-drivers-res', name: 'Active', drivers: onTripDrivers },
        { id: 'online-drivers-res', name: 'Available', drivers: onlineDrivers },
        { id: 'onbreak-drivers-res', name: 'On Break', drivers: onBreakDrivers },
        { id: 'absent-drivers-res', name: 'Absent?', drivers: absentDrivers },
        { id: 'offline-drivers-res', name: 'Offline', drivers: offlineDrivers }
      ]

      driverGroups.forEach(({ id, name, drivers }) => {
        if (drivers.length > 0) {
          driverResource.push({
            id,
            name,
            collapsed:
              id === 'pinned-drivers-res' ? false : collapsedState[id] !== undefined ? collapsedState[id] : true,
            children: drivers,
            type: 'drivers',
            color: 'gray'
          })
        }
      })

      const filteredDriverResource = driverResource.filter(resource => resource.type !== 'initial-driver')

      if (
        onTripDrivers.length > 0 ||
        onlineDrivers.length > 0 ||
        onBreakDrivers.length > 0 ||
        absentDrivers.length > 0 ||
        offlineDrivers.length > 0
      ) {
        return filteredDriverResource
      } else {
        return driverResource
      }
    } else {
      const initialRiderResources: MbscResource[] = [
        {
          id: 'lookup-section',
          name: 'Lookup Section',
          type: 'lookup-section',
          color: 'gray',
          fixed: true
        },
        {
          id: 'initial-rider',
          name: 'Initial Rider',
          type: 'initial-rider',
          color: 'white'
        }
      ]

      if (selectedRider) {
        const updatedRiders = [...initialRiderResources].filter(resource => resource.type !== 'initial-rider')

        updatedRiders.push({
          id: 'selected-rider',
          name: 'Selected Rider',
          type: 'selected-rider',
          color: 'gray'
        })

        return updatedRiders
      }

      if (riders.length > 0) {
        const updatedRiders = [...initialRiderResources].filter(resource => resource.type !== 'initial-rider')

        updatedRiders.push({
          id: 'riders-res',
          name: 'Riders',
          collapsed: false,
          children: riders,
          type: 'riders',
          color: 'gray'
        })

        return updatedRiders
      }

      return initialRiderResources
    }
  }, [drivers, events, vehicles, driverMetrics, selectedLookup, riders, selectedRider, pinnedDrivers])

  const invalids = useMemo(() => {
    return [
      {
        recurring: { repeat: 'daily' },
        resource: [
          'drivers-res',
          'vehicles-res',
          'unassigned-vehicles-res',
          'lookup-section',
          'initial-rider',
          'selected-rider',
          'initial-driver'
        ]
      }
    ]
  }, [])

  const resourcesMap = useMemo(() => {
    const map: { [key: string]: MbscResource } = {}
    resources.forEach((resource: any) => {
      map[resource.id] = resource
      if (resource.children) {
        resource.children.forEach((resource: any) => {
          map[resource.id] = resource
        })
      }
    })
    return map
  }, [resources])

  const assignVehicle = useCallback(ev => {
    ev.preventDefault()
    // TODO: add vehicle assign logic
    alert({ message: 'Assign vehicle here.' })
  }, [])

  const roundOffRevenue = (revenue: number) => {
    if (revenue) {
      return Math.round(revenue)
    } else {
      return 0
    }
  }

  const convertToHoursAndMinutes = (time: number) => {
    const hours = Math.floor(time)
    const minutes = Math.round((time - hours) * 60)

    if (minutes === 0) {
      return `${hours} hrs`
    } else if (hours === 0) {
      return `${minutes} mins`
    } else {
      return `${hours} hrs ${minutes} mins`
    }
  }

  const roundOffPercentage = (percentage: number) => {
    if (percentage) {
      if (percentage % 1 === 0) {
        return percentage
      } else {
        return parseFloat(percentage.toFixed(2))
      }
    } else {
      return 0
    }
  }

  const getColorFromScale = (value: number, max: number, min: number) => {
    const clampedValue = Math.max(min, Math.min(max, value))

    const red = [255, 0, 0]
    const orange = [255, 165, 0]

    const r = red[0]
    const g = Math.round((clampedValue / max) * (orange[1] - red[1]) + red[1])
    const b = Math.round((clampedValue / max) * (orange[2] - red[2]) + red[2])

    return `rgb(${r}, ${g}, ${b})`
  }

  const convertToNameString = (items: any[]): string => {
    return items.map(item => item.service.name).join('\n')
  }

  const truncateText = (text: string): string => {
    return text.length > 30 ? text.slice(0, 25) + '...' : text
  }

  const pinDriver = (resource: MbscResource) => {
    if (pinnedDrivers.includes(`${resource.id}`)) {
      setPinnedDrivers(pinnedDrivers.filter(driverId => driverId !== resource.id))
    } else {
      setPinnedDrivers([...pinnedDrivers, `${resource.id}`])
    }
  }

  // Resource template
  const renderResourceTemplate = useCallback(resource => {
    switch (resource.type) {
      case 'vehicle': {
        return (
          <div style={{ display: 'flex', fontStyle: 'Open Sans', fontSize: '14px' }}>
            <span className='my-resource-dot-assigned ' style={{ background: resource.color, minWidth: '15px' }} />
            <div>
              <div className='mbsc-calendar-font'>
                <b>{resource.name}</b> - {resource.licensePlate}
                <br />
              </div>
              <div className='mbsc-calendar-font-subtitle'>{resource.driver && resource.driver.name}</div>
            </div>
          </div>
        )
      }
      case 'unassigned-vehicle': {
        return (
          <div style={{ display: 'flex', fontStyle: 'Open Sans', fontSize: '14px' }}>
            <span className='my-resource-dot-unassigned' style={{ background: resource.color, minWidth: '15px' }} />
            <div>
              <div className='mbsc-calendar-font'>
                <b>{resource.name}</b> - {resource.licensePlate}
              </div>
              <div className='my-resource-assign'>
                <Link to={`/vehicles/${resource.id}/assign-operator`}>
                  <span className='mbsc-calendar-font-subtitle'>assign driver</span>
                </Link>
              </div>
            </div>
          </div>
        )
      }
      case 'driver': {
        const getTotalVehicleCapacity = (capacities: IAccessAndCapacity[]) => {
          if (capacities && capacities.length > 0) {
            const capacity = capacities[0]
            return capacity.wheelchair + capacity.cot + capacity.amble
          }
          return 0
        }
        const capacity = getTotalVehicleCapacity(resource.vehicleCapacities)
        return (
          <div style={{ columnGap: '8px', display: 'flex', fontStyle: 'Open Sans', fontSize: '14px' }}>
            {resource.vehicle ? (
              <span
                className={`my-resource-dot-assigned ${
                  resource.color === DRIVER_STATUS_COLOR.white ? 'border-light-grey4' : ''
                }`}
                style={{ background: resource.color, minWidth: '15px' }}
              />
            ) : (
              <span
                className={`my-resource-dot-unassigned ${
                  resource.color === DRIVER_STATUS_COLOR.white ? 'border-light-grey4' : ''
                }`}
                style={{ background: resource.color, minWidth: '15px' }}
              />
            )}
            <div className='w100'>
              <div className='flex flex-row justify-between items-center'>
                <div className='flex flex-row'>
                  <b>
                    <Link to={`/drivers/${resource.id}/details`}>
                      <span className='font-black hover-on mbsc-calendar-font'>{resource.name} </span>
                    </Link>
                  </b>
                  {resource.revenuePerHour > 0 && (
                    <UpdatedTooltip text='Revenue Per Hour'>
                      <span
                        className='h6 nowrap'
                        style={{
                          color:
                            roundOffRevenue(resource.revenuePerHour) >= 100
                              ? 'green'
                              : getColorFromScale(roundOffRevenue(resource.revenuePerHour), 99, 0)
                        }}
                      >
                        {'\u00A0'}
                        <span className='h6 font-grey'>rev/hr</span> ${roundOffRevenue(resource.revenuePerHour)}
                      </span>
                    </UpdatedTooltip>
                  )}
                </div>
                <div>
                  {pinnedDrivers.includes(`${resource.id}`) ? (
                    <button
                      type='button'
                      className='unstyled-button'
                      onClick={() => pinDriver(resource)}
                      onKeyDown={e => e.key === 'Enter' && pinDriver(resource)}
                      aria-label='pin driver'
                    >
                      <img src='/images/pin-filled.png' alt='Pin On' className='mbsc-pin-icon' />
                    </button>
                  ) : (
                    <button
                      type='button'
                      className='unstyled-button'
                      onClick={() => pinDriver(resource)}
                      onKeyDown={e => e.key === 'Enter' && pinDriver(resource)}
                      aria-label='pin driver'
                    >
                      <img src='/images/pin.png' alt='Pin On' className='mbsc-pin-icon' />
                    </button>
                  )}
                </div>
              </div>
              <div className='h6 font-grey'>
                {resource.totalClockedInHours > 0 && (
                  <UpdatedTooltip text='Total Hours Clocked In'>
                    <span className={'h6 ' + (resource.totalClockedInHours >= 40 ? 'font-red' : 'font-grey')}>
                      {convertToHoursAndMinutes(resource.totalClockedInHours)}{' '}
                      {(resource.totalTripHours > 0 || resource.revenuePercentage > 0) && `|\u00A0`}
                    </span>
                  </UpdatedTooltip>
                )}
                {resource.totalTripHours > 0 && (
                  <UpdatedTooltip text='Trip Hours'>
                    <span className={'h6 ' + (resource.totalTripHours >= 4 ? 'font-green' : 'font-red')}>
                      {convertToHoursAndMinutes(resource.totalTripHours)}
                      {resource.revenuePercentage > 0 && `,\u00A0`}
                    </span>
                  </UpdatedTooltip>
                )}
                {resource.revenuePercentage > 0 && (
                  <UpdatedTooltip text='Revenue Percentage'>
                    <span
                      className='h6 nowrap'
                      style={{
                        color:
                          roundOffRevenue(resource.revenuePercentage) >= 70
                            ? 'green'
                            : getColorFromScale(roundOffRevenue(resource.revenuePercentage), 70, 0)
                      }}
                    >
                      rev. {roundOffPercentage(resource.revenuePercentage)}%
                    </span>
                  </UpdatedTooltip>
                )}
              </div>
              {resource.vehicle ? (
                <div className='mbsc-calendar-font-subtitle'>{`${resource.vehicle.name}, Capacity: ${capacity} `}</div>
              ) : (
                <Link to={`/drivers/${resource.id}/assign-vehicle`} className='mbsc-calendar-font-subtitle'>
                  assign vehicle
                </Link>
              )}
            </div>
          </div>
        )
      }
      case 'unassigned': {
        return (
          <div className='flex flex-column justify-between h100 mbsc-unassigned-driver-requests'>
            <TimelineViewBusyTimes currentDate={currentDate} setCurrentDate={setCurrentDate} trips={tripEvents} />
            <div className='mbsc-lookup-section'>
              <div className='mbsc-icon-section'>
                {selectedLookup === 'driver' ? (
                  <button
                    type='button'
                    className='unstyled-button'
                    onClick={() => setSelectedLookup('driver')}
                    onKeyDown={e => e.key === 'Enter' && setSelectedLookup('driver')}
                    aria-label='select driver view'
                  >
                    <img src='/images/driver-on.png' alt='Driver On' className='mbsc-lookup-icon' />
                  </button>
                ) : (
                  <button
                    type='button'
                    className='unstyled-button'
                    onClick={() => setSelectedLookup('driver')}
                    onKeyDown={e => e.key === 'Enter' && setSelectedLookup('driver')}
                    aria-label='select driver view'
                  >
                    <img src='/images/driver-off.png' alt='Driver Off' className='mbsc-lookup-icon' />
                  </button>
                )}
                {selectedLookup === 'rider' ? (
                  <button
                    type='button'
                    className='unstyled-button'
                    onClick={() => setSelectedLookup('rider')}
                    onKeyDown={e => e.key === 'Enter' && setSelectedLookup('rider')}
                    aria-label='select rider view'
                  >
                    <img src='/images/rider-on.png' alt='Rider On' className='mbsc-lookup-icon' />
                  </button>
                ) : (
                  <button
                    type='button'
                    className='unstyled-button'
                    onClick={() => setSelectedLookup('rider')}
                    onKeyDown={e => e.key === 'Enter' && setSelectedLookup('rider')}
                    aria-label='select rider view'
                  >
                    <img src='/images/rider-off.png' alt='Rider Off' className='mbsc-lookup-icon' />
                  </button>
                )}
              </div>
              <div className='mbsc-filter-section'>
                <Input
                  label={'Filter'}
                  type='text'
                  className='mobiscroll-input-white form'
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  labelStyle='floating'
                  defaultValue={driverQuery}
                  onChange={onDriverLookupChange}
                />
              </div>
            </div>
          </div>
        )
      }
      case 'lookup-section': {
        return (
          <div className='flex flex-column justify-between h100 mbsc-unassigned-driver-requests'>
            <TimelineViewBusyTimes currentDate={currentDate} setCurrentDate={setCurrentDate} trips={tripEvents} />
            <div className='mbsc-lookup-section mbsc-rider-lookup'>
              <div className='mbsc-icon-section'>
                {selectedLookup === 'driver' ? (
                  <button
                    type='button'
                    className='unstyled-button'
                    onClick={() => setSelectedLookup('driver')}
                    onKeyDown={e => e.key === 'Enter' && setSelectedLookup('driver')}
                    aria-label='select driver view'
                  >
                    <img src='/images/driver-on.png' alt='Driver On' className='mbsc-lookup-icon' />
                  </button>
                ) : (
                  <button
                    type='button'
                    className='unstyled-button'
                    onClick={() => setSelectedLookup('driver')}
                    onKeyDown={e => e.key === 'Enter' && setSelectedLookup('driver')}
                    aria-label='select driver view'
                  >
                    <img src='/images/driver-off.png' alt='Driver Off' className='mbsc-lookup-icon' />
                  </button>
                )}
                {selectedLookup === 'rider' ? (
                  <button
                    type='button'
                    className='unstyled-button'
                    onClick={() => setSelectedLookup('rider')}
                    onKeyDown={e => e.key === 'Enter' && setSelectedLookup('rider')}
                    aria-label='select rider view'
                  >
                    <img src='/images/rider-on.png' alt='Rider On' className='mbsc-lookup-icon' />
                  </button>
                ) : (
                  <button
                    type='button'
                    className='unstyled-button'
                    onClick={() => setSelectedLookup('rider')}
                    onKeyDown={e => e.key === 'Enter' && setSelectedLookup('rider')}
                    aria-label='select rider view'
                  >
                    <img src='/images/rider-off.png' alt='Rider Off' className='mbsc-lookup-icon' />
                  </button>
                )}
              </div>
              <div className='mbsc-filter-section'>
                <Input
                  label={'Filter'}
                  type='text'
                  className='mobiscroll-input-white form'
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  labelStyle='floating'
                  defaultValue={riderQuery}
                  onChange={onRiderLookupChange}
                  disabled={selectedRider !== null}
                />
              </div>
            </div>
          </div>
        )
      }
      case 'initial-rider': {
        return (
          <div className='flex flex-column justify-between h100 mbsc-initial-rider'>
            <div>{riderMessage}</div>
          </div>
        )
      }
      case 'initial-driver': {
        return (
          <div className='flex flex-column justify-between h100 mbsc-initial-driver'>
            <div>{driverMessage}</div>
          </div>
        )
      }
      case 'selected-rider': {
        return (
          <div className='flex flex-column justify-between h100 mbsc-selected-rider'>
            {selectedRider ? (
              <div>
                <div className={`relative flex items-center justify-end`}>
                  <Button ariaLabel='Back button' className='mbsc-flat-btn h5' onClick={() => setSelectedRider(null)}>
                    <GoBackIcon className='icon--small pr1' />
                    Back
                  </Button>
                </div>
                <TimelineViewSelectedRider riderId={selectedRider.id} orgId={props.orgId} />
              </div>
            ) : (
              <div>No Rider</div>
            )}
          </div>
        )
      }
      case 'rider': {
        return (
          <div
            className='list-item flex cursor--pointer mbsc-rider-resource'
            key={resource.id}
            tabIndex={0}
            role='button'
            onClick={() => setSelectedRider(resource)}
            onKeyDown={event => {
              if (event.key === 'Enter' || event.key === ' ') {
                setSelectedRider(resource)
              }
            }}
          >
            {/* Declare name of Avatar */}
            <ImageView
              entityId={resource.id}
              name={`${resource.firstName} ${resource.lastName}`}
              isRounded={true}
              width='30px'
              height='30px'
              className='timeline-view-avatar'
            />
            {/* Declare name of Avatar */}
            <div className='flex flex-column ml2'>
              {truncateText(`${resource.firstName} ${resource.lastName}`).includes('...') ? (
                <UpdatedTooltip text={`${resource.firstName} ${resource.lastName}`}>
                  <span className='mbsc-calendar-font font-black hover-on nowrap'>
                    {truncateText(`${resource.firstName} ${resource.lastName}`)}
                  </span>
                </UpdatedTooltip>
              ) : (
                <span className='mbsc-calendar-font font-black hover-on nowrap'>
                  {`${resource.firstName} ${resource.lastName}`}
                </span>
              )}
              {resource.phone && <span className='mbsc-calendar-font-subtitle'>{resource.phone}</span>}
              <div className=''>
                {resource.serviceMemberships.length > 1 ? (
                  <UpdatedTooltip text={convertToNameString(resource.serviceMemberships)}>
                    <span className='service-name p02 mr1 uppercase font-micro weight-600 font-blue-grey border-light-grey2 inline-block'>
                      {resource.serviceMemberships[0] &&
                        resource.serviceMemberships[0].service &&
                        resource.serviceMemberships[0].service.name}
                    </span>
                    <span className='font-micro weight-600 font-blue-grey'>
                      + {resource.serviceMemberships.length - 1} MORE
                    </span>
                  </UpdatedTooltip>
                ) : (
                  <span className='service-name p02 mr1 uppercase font-micro weight-600 font-blue-grey border-light-grey2 inline-block'>
                    {resource.serviceMemberships[0] &&
                      resource.serviceMemberships[0].service &&
                      resource.serviceMemberships[0].service.name}
                  </span>
                )}
              </div>
            </div>
          </div>
        )
      }
      case 'riders': {
        return <div className='mbsc-rider-parent bold'>{resource.name}</div>
      }
      default: {
        return <div className='bold'>{resource.name}</div>
      }
    }
  }, [assignVehicle, selectedLookup, selectedRider, riderMessage, driverMessage, tripEvents, pinnedDrivers])

  const dropExcludeStatusChange = useCallback(() => {
    const statuses = !showCancelled ? [] : cancelledTripsStatusesDashboard
    setShowCancelled(!showCancelled)
    const { timeStart, timeEnd } = calculateTimeBoundaries(currentDate, viewMode)

    props.updateTripFilters({ ...props.tripFilters, excludeStatuses: statuses, timeStart, timeEnd })
  }, [showCancelled, currentDate])

  // Calendar header template
  const renderHeaderTemplate = useCallback(() => {
    return (
      <React.Fragment>
        <div className='my-header-date'>{dateText}</div>
        <div className='md-work-week-picker mbsc-calendar-font'>
          <SegmentedGroup value={viewMode} onChange={changeView}>
            <Segmented value='day'>Day</Segmented>
            <Segmented value='week'>Week</Segmented>
            <Segmented value='month'>Month</Segmented>
          </SegmentedGroup>
        </div>
        <div className='md-work-week-picker mbsc-calendar-font'>
          <SegmentedGroup value={viewType} onChange={changeView}>
            <Segmented value='timeline'>Timeline</Segmented>
            <Segmented value='timegrid'>Time Grid</Segmented>
          </SegmentedGroup>
        </div>

        {viewType === 'timeline' && (
          <div className='g-flex items-center relative'>
            <GearIcon
              className='cursor--pointer svg-filter-grayscale'
              onClick={() => setToggleControls(prev => !prev)}
            />
            {toggleControls && (
              <TimelineControlsMenu
                timelineSettings={timelineSettings}
                onChange={handleChangeSettings}
                onClose={() => setToggleControls(false)}
              />
            )}
          </div>
        )}

        <div className='mbsc-flex ml2'>
          <div className='flex items-center'>
            <label className='h5 font-dark-grey mr2'>Show Cancelled: </label>
            <Toggle state={showCancelled} onClick={dropExcludeStatusChange} />
          </div>
        </div>

        <div className='my-header-controls mbsc-flex mbsc-flex-1-0 md-timezone-header'>
          {viewType === 'timeline' && (
            <div className='md-meeting-planner-zone md-meeting-planner-work'>working hours</div>
          )}
          <CalendarPrev />
          <CalendarNext />
        </div>
      </React.Fragment>
    )
  }, [currentDate, timelineSettings, toggleControls, viewMode, viewType, showCancelled, dateText])

  // Calendar event template
  // Unassigned trips
  const renderEventTemplate = useCallback(data => {
    // TODO: use the needed fields from event
    // const event = data.original;
    const titleWithIcon = (pickUp: string | undefined, dropOff: string | undefined, riderCount: number) => {
      return (
        <div className='my-event-title mbsc-calendar-font'>
          {`${pickUp} `} <ArrowRightWithTailSM />
          {` ${dropOff} `} &emsp;+{riderCount || 0}
        </div>
      )
    }

    const displayETA = (lastStatus: string | undefined) => {
      if (
        lastStatus === TripStatuses.ACCEPTED ||
        lastStatus === TripStatuses.AT_PICK_UP ||
        lastStatus === TripStatuses.TO_PICK_UP
      ) {
        return (
          <div className='flex items-center justify-between mt1 h6'>
            <p className='m0 font-black mbsc-calendar-font'>
              Estimated Pickup &emsp;
              <ETADisplay
                className='font-blue bold mbsc-calendar-font'
                origin={data.original.etaOrigin}
                destination={data.original.etaDestinationPickup}
              />
            </p>
          </div>
        )
      } else if (lastStatus === TripStatuses.PICKED_UP) {
        return (
          <div className='flex items-center justify-between mt1 h6'>
            <p className='m0 font-black mbsc-calendar-font'>
              Estimated Dropoff &emsp;
              <ETADisplay origin={data.original.etaOrigin} destination={data.original.etaDestinationDropoff} />
            </p>
          </div>
        )
      } else {
        return ''
      }
    }

    const getAddressLocation = (location: ILocationV2) => {
      if ((location && location.city) || (location && location.placeName)) {
        return location.city || location.placeName
      }

      const city = CITIES.find(ct => location && location.fullAddress.includes(ct))
      if (city) {
        return city
      }
      return location ? location.fullAddress : '-'
    }

    const PopupContent = () => (
      <Link to={`/trips/${data.id}`}>
        <div style={{ backgroundColor: '#ffff', padding: '10px', border: '2px solid #777777' }}>
          <div style={{ color: '#333' }}>
            {titleWithIcon(
              getAddressLocation(data.original.pickupLocation),
              getAddressLocation(data.original.dropOffLocation),
              data.original.riderCount
            )}
          </div>

          <div style={{ color: '#333' }} className='my-event-sub-title mbsc-calendar-font'>
            {data.original.product && data.original.product.hasOwnProperty('name') ? data.original.product.name : ''}{' '}
          </div>

          <div style={{ color: '#333' }} className='my-event-sub-title mbsc-calendar-font'>
            {displayETA(data.original.lastStatus)}
          </div>

          <div style={{ display: 'flex', alignItems: 'stretch', width: '300px' }}>
            <div style={{ width: '70%' }}>
              <TripDetailLocation iTripStatus={data.original.lastStatus} riderTrip={data.original.trip} />
            </div>
            <div
              style={{
                color: '#333',
                width: '30%',
                display: 'flex',
                flexDirection: 'column',
                marginTop: '15px',
                fontSize: '14px',
                fontFamily: 'Open sans'
              }}
            >
              <div style={{ flexGrow: 1 }}>{moment(data.original.start).format('hh:mm A')}</div>
              <div style={{ flexGrow: 1 }}>{moment(data.original.end).format('hh:mm A')}</div>
            </div>
          </div>
          <div style={{ fontWeight: 'bold', color: '#333', padding: '5px', fontSize: '12px' }}> Notes: </div>
          <div style={{ color: '#333' }}>
            {' '}
            {data.original.trip && data.original.trip.notes ? data.original.trip.notes : ''}
          </div>
        </div>
      </Link>
    )

    const productId =
      data && data.original && data.original.product && data.original.product.productId
        ? data.original.product.productId
        : ''

    if (data.original.type === 'shift') {
      return (
        <span className={data.resource}>
          {viewType === 'timegrid' && (
            <div className='mbsc-schedule-event-background mbsc-ios' style={{ background: data.color, opacity: 1 }} />
          )}
          {/* <div className='mbsc-schedule-event-inner mbsc-ios mbsc-schedule-event-small-height'> */}
          <div
            className={
              viewType === 'timegrid'
                ? 'mbsc-schedule-event-inner mbsc-ios mbsc-schedule-event-small-height'
                : 'schedule-event-container'
            }
          >
            {data.id && (
              <Popup
                trigger={
                  <div
                    className={`my-event ${data.original.cssClass} mbsc-calendar-font rounded`}
                    style={{ background: data.color }}
                  >
                    <div
                      className={
                        viewType === 'timeline'
                          ? 'my-event-inner flex items-center'
                          : 'my-event-inner flex justify-center flex-column'
                      }
                      style={{ ...(viewType === 'timeline' && { marginRight: '8px' }) }}
                    >
                      <div className='schedule-event'>
                        <span className={'schedule-event-title'}>{data.title}</span>
                        <span className='schedule-event-subtitle'>
                          {data.start} - {data.end}
                        </span>
                      </div>
                    </div>
                  </div>
                }
                position={['top center', 'bottom right', 'bottom left']}
                closeOnDocumentClick={true}
                closeOnEscape={true}
              >
                {''}
              </Popup>
            )}
          </div>
        </span>
      )
    }

    return (
      <span className={data.resource}>
        {viewType === 'timegrid' && (
          <div className='mbsc-schedule-event-background mbsc-ios' style={{ background: data.color, opacity: 1 }} />
        )}
        {/* <div className='mbsc-schedule-event-inner mbsc-ios mbsc-schedule-event-small-height'> */}
        <div
          className={
            viewType === 'timegrid' ? 'mbsc-schedule-event-inner mbsc-ios mbsc-schedule-event-small-height' : ''
          }
        >
          {data.id && (
            <Popup
              trigger={
                <div
                  className={`my-event ${data.original.cssClass} mbsc-calendar-font`}
                  style={{ background: data.color }}
                >
                  <div
                    className={
                      viewType === 'timeline'
                        ? 'my-event-inner flex items-center'
                        : 'my-event-inner flex justify-center flex-column'
                    }
                    style={{ ...(viewType === 'timeline' && { marginRight: '8px' }) }}
                  >
                    <img
                      src={getURL(productId)}
                      style={{ height: '30px', width: '30px', objectFit: 'cover', padding: '8px', alignSelf: 'center' }}
                      onError={e => (e.currentTarget.src = '/images/car.png')}
                    />
                    <div>
                      <div className={viewType === 'timegrid' ? 'my-event-title-wrap' : 'my-event-title'}>
                        {titleWithIcon(
                          getAddressLocation(data.original.pickupLocation),
                          getAddressLocation(data.original.dropOffLocation),
                          data.original.riderCount
                        )}
                      </div>
                      <div className='my-event-sub-title'>
                        {data.original.product && data.original.product.hasOwnProperty('name')
                          ? data.original.product.name
                          : ''}{' '}
                      </div>
                    </div>
                  </div>
                </div>
              }
              position={['top center', 'bottom right', 'bottom left']}
              closeOnDocumentClick={true}
              closeOnEscape={true}
            >
              {/* <PopupContent /> */}
              {''}
            </Popup>
          )}
        </div>
      </span>
    )
  }, [viewType, viewMode])

  const renderResourceHeader = useCallback(() => {
    if (selectedLookup === 'driver') {
      return <div className='mbsc-unassigned-requests-text'>Unassigned Requests</div>
    } else {
      return <div />
    }
  }, [selectedLookup])

  const onEventCreate = useCallback(args => {
    const resourceId = args.event.resource
    const resource = resourcesMap[resourceId]
    if (resource.type === 'driver') {
      const vehicle = vehicles.find(v => v.operator.id === resourceId)
      if (vehicle) {
        args.event.resource = [resourceId, vehicle.id]
      } else {
        // TODO: implement picking a vehicle
        alert({ message: 'Pick a vehicle here.' })
      }
    } else if (resource.type === 'vehicle') {
      const driver = drivers.find(d => d.id === resource.operator.id)
      if (driver) {
        args.event.resource = [resourceId, driver.id]
      }
    } else if (resource.type === 'unassigned-vehicle') {
      // TODO: implement picking a driver
      alert({ message: 'Pick a driver here.' })
    }
  }, [drivers, vehicles, resourcesMap])

  const onEventUpdate = useCallback(async (args: any) => {
    const oldEvent = args.oldEvent
    const oldTime = +new Date(oldEvent.start)
    const newEvent = args.event
    const newTime = +newEvent.start
    const timeDiff = Math.abs(newTime - oldTime)
    props.setCurrentTrip(newEvent.id)
    // Check if resource changed
    if (oldEvent.resource !== newEvent.resource) {
      const driver =
        typeof newEvent.resource === 'string'
          ? props.drivers.find(driver => driver.id === newEvent.resource)
          : props.drivers.find(driver => newEvent.resource.find((newResourceId: string) => newResourceId === driver.id))
      if (driver) {
        const simpleDriver: ISimpleDriverDTO = {
          id: driver.id,
          operatorId: driver.id,
          firstName: driver.firstName,
          lastName: driver.lastName,
          phone: driver.phone
        }
        newEvent.resource = driver.id
        if (newEvent.resource.includes('unassigned-res')) {
          const params: ITripEdit = {
            prevOperator: oldEvent.trip.operator
              ? oldEvent.trip.operator.firstName + ' ' + oldEvent.trip.operator.lastName
              : '',
            operator: 'unassigned',
            tripId: newEvent.trip.id
          }

          await props.saveData(params).then(() => {
            if (newEvent.trip.groupRideId !== null) {
              props.unAssignScheduledGroupRideOperator(newEvent.trip.groupRideId).then(() => reloadTrips())
            }
          })
        } else {
          props.assignOperator(newEvent.id, newEvent.lastStatus, simpleDriver, false).then(() => {
            if (newEvent.trip.groupRideId !== null) {
              props.assignScheduledGroupRideOperator(newEvent.trip.groupRideId, simpleDriver).then(() => reloadTrips())
            }
          })
        }
      }
      if (!oldEvent.resource.includes('unassigned-res') && newEvent.resource.includes('unassigned-res')) {
        const params: ITripEdit = {
          prevOperator: oldEvent.trip.operator
            ? oldEvent.trip.operator.firstName + ' ' + oldEvent.trip.operator.lastName
            : '',
          operator: 'unassigned',
          tripId: newEvent.trip.id
        }

        await props.saveData(params).then(() => {
          if (newEvent.trip.groupRideId !== null) {
            props.unAssignScheduledGroupRideOperator(newEvent.trip.groupRideId).then(() => reloadTrips())
          }
        })
      }

      if (timeDiff > 900000) {
        // If changed more than 15 minutes, display a message and reject the change
        toast({
          message: 'The times changed more than 15 minutes. Update rejected.'
        })
        return false
      } else if (timeDiff < 0) {
        // If times changed, display a warning
        toast({
          message: 'The event times has been changed!'
        })
      }
    }
    return null
  }, [props.drivers])

  // Event tooltip related functions
  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
    }
  }, [])

  const openScheduleTooltip = useCallback(async args => {
    const { event } = args

    if (timer.current) {
      clearTimeout(timer.current)
      timer.current = undefined
    }

    setScheduleInfo(event)

    const current = anchorRef.current

    if (current) {
      current.style.left = `${args.domEvent.x}px`
      current.style.top = `${args.domEvent.y}px`
    }

    setIsScheduleTooltipOpen(true)
    setTooltipLoading(false)
  }, [scheduleInfo, tooltipAnchor, isScheduleTooltipOpen])

  const openEventTooltip = useCallback(async args => {
    const { event } = args

    if (!event.id.includes('mbsc')) {
      setEventInfo(event)
      setTooltipLoading(true)
      const current = tripRef.current

      if (current) {
        current.style.left = `${args.domEvent.x}px`
        current.style.top = `${args.domEvent.y}px`
      }

      setTooltipOpen(true)

      if (timer.current) {
        clearTimeout(timer.current)
        timer.current = undefined
      }

      try {
        const tripStatus = await tripService.getManyStatusesByTripId(event.id)

        const lastStatus = tripStatus[0].status

        const eventWithStatus = {
          ...event,
          lastStatus
        }

        const { color, cssClass } = getTripBlockColor(eventWithStatus, event.end)

        const eventWithUpdatedStatus = {
          ...event,
          color,
          cssClass,
          lastStatus
        }

        if (lastStatus !== event.lastStatus) {
          props.updateSingleTrip(eventWithUpdatedStatus)
        }

        const savedDestinations = eventDestinations.find(destination => destination.id === event.id)

        if (savedDestinations === null || savedDestinations === undefined) {
          try {
            const { destinations } = (await getTripDetails(event.id)) || {}

            if (destinations) {
              const newDestination = {
                id: event.id,
                destinations
              }
              const updatedDestinations = [...eventDestinations, newDestination]
              setEventDestinations(updatedDestinations)
            }

            const eventWithDestinations = { ...eventWithUpdatedStatus, destinations: destinations || [] }

            setEventInfo(eventWithDestinations)
          } catch (error) {
            console.error('Error fetching trip details:', error)
            setEventInfo(eventWithUpdatedStatus)
          } finally {
            setTooltipLoading(false)
          }
        } else {
          const eventWithDestinations = { ...eventWithUpdatedStatus, destinations: savedDestinations.destinations }

          setEventInfo(eventWithDestinations)
          setTooltipLoading(false)
        }
      } catch (error) {
        console.error('Error fetching trip statuses:', error)
      }
    }
  }, [eventInfo, tooltipAnchor, isTooltipOpen])

  const handleEventHoverIn = useCallback(args => {
    if (args.event.original && args.event.original.type === 'shift') {
      openScheduleTooltip(args)
    } else {
      openEventTooltip(args)
    }
  }, [openEventTooltip])

  const handleEventHoverOut = useCallback(() => {
    if (!timer.current) {
      if (!hoveringTooltip) {
        timer.current = setTimeout(() => {
          setEventInfo(undefined)
          setScheduleInfo(undefined)
          setTooltipLoading(false)
          setTooltipOpen(false)
          setIsScheduleTooltipOpen(false)
        }, 200)
      }
    }
  }, [eventInfo, tooltipAnchor, isTooltipOpen, scheduleInfo, isScheduleTooltipOpen, hoveringTooltip])

  const handleMouseEnter = useCallback(() => {
    setHoveringTooltip(true)
    if (timer.current) {
      clearTimeout(timer.current)
      timer.current = undefined
    }
  }, [eventInfo, tooltipAnchor, isTooltipOpen, hoveringTooltip])

  const handleMouseLeave = useCallback(() => {
    setHoveringTooltip(false)
    timer.current = setTimeout(() => {
      setEventInfo(undefined)
      setTooltipOpen(false)
    }, 200)
  }, [eventInfo, tooltipAnchor, isTooltipOpen, hoveringTooltip])

  const handleTooltipClose = useCallback(() => {
    setEventInfo(undefined)
    setTooltipOpen(false)
  }, [eventInfo, tooltipAnchor, isTooltipOpen])

  const handleScheduleMouseEnter = useCallback(() => {
    setHoveringTooltip(true)
    if (timer.current) {
      clearTimeout(timer.current)
      timer.current = undefined
    }
  }, [scheduleInfo, tooltipAnchor, isScheduleTooltipOpen, hoveringTooltip])

  const handleScheduleMouseLeave = useCallback(() => {
    setHoveringTooltip(false)
    timer.current = setTimeout(() => {
      setScheduleInfo(undefined)
      setIsScheduleTooltipOpen(false)
    }, 200)
  }, [scheduleInfo, tooltipAnchor, isScheduleTooltipOpen, hoveringTooltip])

  const handleScheduleTooltipClose = useCallback(() => {
    setScheduleInfo(undefined)
    setIsScheduleTooltipOpen(false)
  }, [scheduleInfo, tooltipAnchor, isScheduleTooltipOpen])
  // END of event tooltip related functions

  const reloadTrips = () => {
    const { timeStart, timeEnd } = calculateTimeBoundaries(currentDate, viewMode)

    props.fetchTrips({
      orgId: props.orgId,
      timeField: 'createdAndPickup',
      timeStart,
      timeEnd,
      sortBy: ['created-asc'],
      getDashBoardData: true,
      status: pendingAndActiveTripStatuses,
      skip: 0,
      take: 1000
    })
  }
  const onEventCreated = useCallback(args => {
    // TODO: save created event to database
  }, [])

  const onEventUpdated = useCallback(args => {
    // TODO: save updated event to database
  }, [])

  const onSelectedDateChange = useCallback(args => {
    setCurrentDate(args.date)

    const { timeStart, timeEnd } = calculateTimeBoundaries(args.date, viewMode)

    props.updateTripFilters({
      ...props.tripFilters,
      timeStart,
      timeEnd
    })
  }, [setCurrentDate, viewMode, viewType])

  const changeView = (event: ChangeEvent<HTMLInputElement>) => {
    let calView: MbscEventcalendarView
    const value = event.target.value

    const isDay = value === 'day'
    const isWeek = value === 'week'
    const isMonth = value === 'month'
    const isTimeline = value === 'timeline'

    const isViewTypeTimeline = viewType === 'timeline'
    const isViewModeDay = viewMode === 'day'

    const commonConfig = {
      timeCellStep: 5,
      timeLabelStep: 30
    }

    if (isDay) {
      if (isViewTypeTimeline) {
        calView = {
          timeline: {
            type: 'day',
            ...timelineSettings
          }
        }
      } else {
        calView = {
          schedule: {
            type: 'day',
            ...commonConfig
          }
        }
      }
    } else if (isWeek) {
      if (isViewTypeTimeline) {
        calView = {
          timeline: {
            type: 'week',
            ...timelineSettings
          }
        }
      } else {
        calView = {
          schedule: {
            type: 'week'
          }
        }
      }
    } else if (isMonth) {
      if (isViewTypeTimeline) {
        calView = {
          timeline: {
            type: 'month',
            ...timelineSettings
          }
        }
      } else {
        calView = {
          schedule: {
            type: 'month'
          }
        }
      }
    } else if (isTimeline) {
      if (isViewModeDay) {
        calView = {
          timeline: {
            type: 'day',
            ...timelineSettings
          }
        }
      } else {
        calView = {
          timeline: {
            type: 'week',
            ...timelineSettings
          }
        }
      }
    } else {
      if (isViewModeDay) {
        calView = {
          schedule: {
            type: 'day',
            ...commonConfig
          }
        }
      } else {
        calView = {
          schedule: {
            type: 'week'
          }
        }
      }
    }

    setToggleControls(false)
    if (isDay || isWeek || isMonth) {
      setViewMode(value as 'day' | 'week' | 'month')
    } else {
      setViewType(value)
    }
    setView(calView)
  }

  let mbscColors: IMbscColors[] = []
  let mbscInvalid: IMbscColors[] = []
  const formatToMbscDay = (days: string[]): string => {
    return days
      .map(day =>
        day
          .split('')
          .slice(0, 2)
          .join('')
          .toUpperCase()
      )
      .join(',')
  }

  const mapOperatorScheduleToTimeline = ({
    resource,
    schedules
  }: {
    resource: string
    schedules: IDriverScheduleDTO[]
  }) => {
    const startOfDay = moment()
      .startOf('day')
      .format('HH:mm')
    const endOfDay = moment()
      .endOf('day')
      .format('HH:mm')
    let driverUnavailableDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    let groupScheduleByDays: IDriverScheduleDTO[] = []
    /**
     * Filter driver schedule by day to handle scenario of split time availability
     */
    driverUnavailableDays.forEach(weekDays => {
      const scheduleForTheDay = schedules.filter(sched => sched.days.includes(weekDays))
      if (scheduleForTheDay.length) {
        const mapDaysToSchedule = scheduleForTheDay
          .map(schedule => {
            return {
              ...schedule,
              days: [weekDays]
            }
          })
          .sort((a, b) => moment(a.from, 'HH:mm').valueOf() - moment(b.from, 'HH:mm').valueOf())
        groupScheduleByDays = [...groupScheduleByDays, ...mapDaysToSchedule]
      }
    })

    groupScheduleByDays.forEach((schedule: IDriverScheduleDTO, index: number) => {
      const { days, from: start, until: end } = schedule
      /**
       * Filter out unselected days on driver schedule settings and will be tag as unavailable
       */
      days.forEach(availableDay => {
        const filter = driverUnavailableDays.filter(day => day !== availableDay)
        driverUnavailableDays = filter
      })

      /**
       * Driver available
       */
      const driverAvailableSchedule = [
        {
          background: driverAvailableBg,
          end,
          recurring: {
            repeat: 'weekly',
            weekDays: formatToMbscDay(days)
          },
          resource,
          start
        }
      ]
      /**
       * Driver unavailable(time before and after availability specified on drivers schedule)
       */
      const driverUnavailableSchedule = [
        {
          background: driverUnavailableBg,
          end: start,
          recurring: {
            repeat: 'weekly',
            weekDays: formatToMbscDay(days)
          },
          resource,
          start:
            !!index && days[0] === groupScheduleByDays[index - 1].days[0]
              ? groupScheduleByDays[index - 1].until
              : startOfDay
        },
        {
          background: driverUnavailableBg,
          end:
            index !== groupScheduleByDays.length - 1 && days[0] === groupScheduleByDays[index + 1].days[0]
              ? ''
              : endOfDay,
          recurring: {
            repeat: 'weekly',
            weekDays: formatToMbscDay(days)
          },
          resource,
          start: end === '00:00' ? '23:59' : end
        }
      ]

      mbscColors = [...mbscColors, ...driverAvailableSchedule, ...driverUnavailableSchedule]
      mbscInvalid = [...mbscInvalid, ...driverUnavailableSchedule]
    })

    /**
     * Unselected days on drivers settings tag as unavailable
     */
    if (driverUnavailableDays.length > 0) {
      const unselectedDays = {
        background: driverNoScheduleBg,
        end: endOfDay,
        recurring: {
          repeat: 'weekly',
          weekDays: formatToMbscDay(driverUnavailableDays)
        },
        resource,
        start: startOfDay
      }
      mbscColors = [...mbscColors, unselectedDays]
      mbscInvalid = [...mbscInvalid, unselectedDays]
    }
  }

  const defaultColors = [
    {
      background: driverNoScheduleBg,
      start: '00:00',
      end: '23:59'
    },
    {
      background: 'white',
      resource: ['unassigned-res', 'drivers-res', 'vehicles-res', 'unassigned-vehicles-res'],
      start: '00:00',
      end: '23:59'
    }
  ]

  const colors = viewType === 'timeline' && mbscColors.length > 0 ? [...defaultColors, ...mbscColors] : []
  /**
   * Prevent the user to create event/trips in timeline when driver is unavailable
   */
  const invalid = viewType === 'timeline' && mbscInvalid.length > 0 ? [...mbscInvalid, ...invalids] : [...invalids]

  const myBeforeBuffer = useCallback((args: MbscCalendarEventData) => {
    const event = args.original!
    const color = event.color

    if (viewType === 'timeline') {
      return (
        <div className='md-buffer md-before-buffer' style={{ background: color, fontSize: '9px' }}>
          Load
          <span className='md-buffer-time'>{event.bufferBefore} m</span>
          <div className='md-buffer-tail' style={{ background: color }} />
        </div>
      )
    } else {
      return (
        <div className='md-buffer md-before-buffer-grid' style={{ background: color }}>
          <span className='md-buffer-time'>Load: {event.bufferBefore} m</span>
          <div className='md-buffer-tail' style={{ background: color }} />
        </div>
      )
    }
  }, [viewType, viewMode])

  const myAfterBuffer = useCallback((args: MbscCalendarEventData) => {
    const event = args.original!
    const color = event.color

    if (viewType === 'timeline') {
      return (
        <div className='md-buffer md-after-buffer' style={{ background: color, fontSize: '8px' }}>
          Unload
          <span className='md-buffer-time'>{event.bufferAfter} m</span>
          <div className='md-buffer-tail' style={{ background: color }} />
        </div>
      )
    } else {
      return (
        <div className='md-buffer md-after-buffer-grid' style={{ background: color }}>
          <span className='md-buffer-time'>Unload: {event.bufferAfter} m</span>
          <div className='md-buffer-tail' style={{ background: color }} />
        </div>
      )
    }
  }, [viewType, viewMode])

  const getBucketName = () => {
    return process.env.REACT_APP_ENV === 'production'
      ? process.env.REACT_APP_S3_BUCKET_PROD
      : process.env.REACT_APP_S3_BUCKET_DEV
  }

  const getURL = (productId: string) => {
    const sha1 = require('sha1')

    return `https://${getBucketName()}.s3.amazonaws.com/uploads/${sha1(productId)}.png`
  }

  const toggleCollapse = (id: string, collapsed: boolean) => {
    setCollapsedState(prev => ({
      ...prev,
      [id]: collapsed // Toggle collapsed state
    }))
  }

  const riderAutocompleteSearchDebounced = debounce(500, (value: string) => {
    if (value.length === 0) {
      setRiderMessage(initialRiderMessage)
      setRiders([])
    } else {
      const dto: IRiderFilters = {
        search: value,
        orgId: props.orgId,
        isActive: true,
        isArchived: false
      }
      queryRider(dto)
    }
  })

  const driverAutocompleteSearchDebounced = debounce(500, (value: string) => {
    setDriverQuery(value)
  })

  const onRiderLookupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value
    setRiderQuery(searchString)
    riderAutocompleteSearchDebounced(searchString)
  }

  const onDriverLookupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value
    driverAutocompleteSearchDebounced(searchString)
  }

  const queryRider = async (dto: IRiderFilters) => {
    try {
      const payload = await riderService.getMany(dto)
      const riders = payload.data.items

      const formattedRiders = riders.map((rider: any) => {
        return {
          id: rider.id,
          name: rider.name,
          firstName: rider.firstName,
          lastName: rider.lastName,
          phone: rider.phone,
          email: rider.email,
          serviceMemberships: rider.serviceMemberships,
          birthDate: rider.birthDate,
          type: 'rider'
        }
      })
      if (formattedRiders.length === 0) {
        setRiderMessage(noResultFoundRiderMessage)
      }
      setRiders(formattedRiders)
    } catch (error) {
      console.log(error)
      setRiderMessage('An error occurred while searching. Please try again.')
      setRiders([])
    }
  }

  const debouncedSetCurrentDate = useCallback(
    debounce(100, (date: string) => {
      setDateText(date)
    }),
    []
  )

  const observerRef = useRef<MutationObserver | null>(null)

  useEffect(() => {
    const targetNode: HTMLDivElement | null = document.querySelector('.current-day')

    if (!targetNode) {
      return
    }

    observerRef.current = new MutationObserver(() => {
      if (targetNode && targetNode.innerText) {
        debouncedSetCurrentDate(targetNode.innerText)
      }
    })

    observerRef.current.observe(targetNode, {
      childList: true,
      characterData: true,
      subtree: true
    })

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
    }
  }, [])

  const renderDay = (args: MbscCalendarDayData) => {
    return (
      <div className='h5 h100 flex pl1 current-day' style={{ paddingTop: '4px' }}>
        {formatDate(dateFormat, args.date)}
      </div>
    )
  }

  return (
    <React.Fragment>
      <Eventcalendar
        onResourceCollapse={args => toggleCollapse(typeof args.resource === 'string' ? args.resource : '', true)}
        onResourceExpand={args => toggleCollapse(typeof args.resource === 'string' ? args.resource : '', false)}
        colors={colors}
        className={viewMode === 'day' ? 'mbsc-timegrid-day' : 'mbsc-timegrid-week'}
        view={view}
        dragTimeStep={1}
        dragToCreate={false}
        dragToMove={false}
        dragToResize={false}
        data={events}
        eventOverlap={true}
        invalid={invalids}
        resources={resources}
        selectedDate={currentDate}
        onEventCreate={onEventCreate}
        onEventCreated={onEventCreated}
        onEventHoverIn={handleEventHoverIn}
        onEventHoverOut={handleEventHoverOut}
        onEventUpdate={onEventUpdate}
        onEventUpdated={onEventUpdated}
        onSelectedDateChange={onSelectedDateChange}
        renderResource={renderResourceTemplate}
        renderHeader={renderHeaderTemplate}
        renderScheduleEvent={renderEventTemplate}
        renderBufferBefore={myBeforeBuffer}
        renderBufferAfter={myAfterBuffer}
        renderResourceHeader={renderResourceHeader}
        showEventBuffer={true}
        themeVariant='light'
        renderDay={renderDay}
      />
      <div ref={anchorRef} style={{ position: 'absolute', width: '1px', height: '1px', pointerEvents: 'none' }} />
      <div ref={tripRef} style={{ position: 'absolute', width: '1px', height: '1px', pointerEvents: 'none' }} />
      {viewType === 'timeline' && isTooltipOpen === true && (
        <TimelineEventPopup
          driveTimes={driveTimes}
          eventInfo={eventInfo}
          isTooltipOpen={isTooltipOpen}
          tooltipAnchor={tripRef.current ? tripRef.current : undefined}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          handleTooltipClose={handleTooltipClose}
          loading={tooltipLoading}
        />
      )}
      {viewType === 'timeline' && isScheduleTooltipOpen === true && (
        <TimelineSchedulePopup
          eventInfo={scheduleInfo}
          isTooltipOpen={isScheduleTooltipOpen}
          tooltipAnchor={anchorRef.current ? anchorRef.current : undefined}
          handleMouseEnter={handleScheduleMouseEnter}
          handleMouseLeave={handleScheduleMouseLeave}
          handleTooltipClose={handleScheduleTooltipClose}
          loading={tooltipLoading}
        />
      )}
    </React.Fragment>
  )
}

export default TripsSchedulerCalendar



// WEBPACK FOOTER //
// ./src/components/trips/timeline-view/TripsSchedulerCalendarv1.tsx